import { observer } from 'mobx-react';
import React from 'react';
import { AnalyticsTrigger, Card, CardContent, Grid, GridColumn, Heading, Modal, ModalContent, Separator } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import GravityForm from '../forms/GravityForm';
import StartingCompanyModalPackageCard from './StartingCompanyModalPackageCard';
import StartingCompanySubmittedModalContent from './StartingCompanySubmittedModalContent';

export interface StartingCompanySelectedPackage {
  title: string;
  icon: string;
  value: string;
}

interface StartingCompanyFormModalProps {
  packages: StartingCompanySelectedPackage[];
  formName: string;
  packagesTechnicalParameter: string;
  open: boolean;
  setModalOpen: (open: boolean) => void;
}

const StartingCompanyFormModal: React.FC<StartingCompanyFormModalProps> = (props) => {
  const [sent, setSent] = React.useState(false);
  const [error, setError] = React.useState(false);
  const translate = React.useContext(TranslationsContext).translate;

  const onCloseHandler = () => {
    props.setModalOpen(false);
    setSent(false);
    setError(false);
  };

  const modalContent = () => {
    return (
      <>
        <Heading id="modal-heading" element="h1" className="h3">
          {translate('starting-company.modal.title')}
        </Heading>
        <Separator color="invisible" spacing="xxsmall" />
        <p>{translate('starting-company.modal.sub-title')}</p>
        <Separator color="invisible" spacing="xsmall" />
        <Card>
          <CardContent>
            <Heading element="h2" className="h4 text-bold">
              {translate('starting-company.modal.services')}
            </Heading>
            <Separator color="invisible" spacing="xxsmall" />
            <Grid equalHeight={true}>
              {props.packages.map((pck) => (
                <StartingCompanyModalPackageCard key={pck.value} {...pck} />
              ))}
            </Grid>
          </CardContent>
        </Card>
        <Separator color="invisible" spacing="xxsmall" />
        <Grid>
          <GridColumn width={['xs-12', 'sm-9']}>
            <AnalyticsTrigger
              trigger={{
                id: `Submit - ${props.formName}`,
                callback: 'onSubmit',
              }}
            >
              <GravityForm
                buttonGridProps={{ align: ['start-xs'] }}
                submitButtonProps={{
                  iconRight: '#arrow-right',
                  type: 'expressive',
                }}
                fieldValueProviders={[
                  {
                    technicalParameter: props.packagesTechnicalParameter,
                    data: props.packages.map((p) => p.value).join(','),
                    fixedValue: true,
                  },
                ]}
                name={props.formName}
                onSubmitSuccess={() => setSent(true)}
                onSubmitFailure={() => {
                  setSent(true);
                  setError(true);
                }}
              />
            </AnalyticsTrigger>
          </GridColumn>
        </Grid>
      </>
    );
  };

  return (
    <Modal aria-describedby="modal-heading" hasContentComponent={true} size="8-col" isOpen={props.open} onClose={() => onCloseHandler()}>
      <ModalContent>{sent ? <StartingCompanySubmittedModalContent error={error} onCloseHandler={onCloseHandler} /> : modalContent()}</ModalContent>
    </Modal>
  );
};

export default observer(StartingCompanyFormModal);
